import { useMemo, useState } from 'react';
import styled from 'styled-components/macro'


const PaginationBtn = styled.button`
  width: 30px;
  height: 30px;
  color: #808183;
  border-bottom: 1px solid rgba(171, 154, 144, 0.3);  
  border-top: 1px solid rgba(171, 154, 144, 0.3);  
  border-right: 1px solid rgba(171, 154, 144, 0.3);  
  border-left: none;  
  cursor: pointer;
  background: transparent;
  opacity: 0.9;
  font-family: "Montserrat",sans-serif;
  display: block;
`

const PaginationBtnFirst = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  color: #808183;
  border: 1px solid rgba(145,114,114,0.2);
  cursor: pointer;
  background: transparent;
  border-radius: 10px 0 0 10px;
  opacity: 0.9;
`

const PaginationBtnLast = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  color: #808183;
  border-right: 1px solid rgba(145,114,114,0.2); 
  border-top: 1px solid rgba(145,114,114,0.2);
  border-bottom: 1px solid rgba(145,114,114,0.2);
  border-left: none;   
  cursor: pointer;
  background: transparent;
  border-radius: 0 10px 10px 0;
  opacity: 0.9;
`

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
`

export function usePagination({ initialPage = 1, totalPages, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  
  const getPaginationPages = (current, total) => {
    const pages = [];
    pages.push(1);

    if (current <= 3) {
      for (let i = 2; i <= Math.min(5, total - 1); i++) {
        pages.push(i);
      }
      if (total > 6) pages.push('...');
    } else if (current > 3 && current < total - 2) {
      pages.push('...');
      pages.push(current - 1);
      pages.push(current);
      pages.push(current + 1);
      pages.push('...');
    } else if (current >= total - 2) {
      pages.push('...');
      for (let i = total - 4; i < total; i++) {
        if (i > 1) pages.push(i);
      }
    }

    if (total > 1) pages.push(total);

    return pages;
  };

  const pageChangeHandler = (page) => {
    setCurrentPage(page);
    onPageChange?.(page);
  }

  const paginationPages = useMemo(() => getPaginationPages(currentPage, totalPages), [currentPage, totalPages]);

  const paginationComponent = totalPages > 1 && (
    <PaginationWrapper>
      <PaginationBtnFirst onClick={() => pageChangeHandler(1)} disabled={currentPage === 1}>
        {`<<`}
      </PaginationBtnFirst>

      {paginationPages.map((page, index) =>
        page === '...' ? (
          <PaginationBtn key={`dots-${index}`}>
            ...
          </PaginationBtn>
        ) : (
          <PaginationBtn
            key={page}
            onClick={() => pageChangeHandler(Number(page))}
            style={{
              color: currentPage === page ? '#FFFFFF' : '#808183',
              background: currentPage === page ? '#FE6103' : 'transparent',
              opacity: currentPage === page ? '0.35' : '0.9',

            }}
          >
            {page}
          </PaginationBtn>
        )
      )}

      <PaginationBtnLast onClick={() => pageChangeHandler(totalPages)} disabled={currentPage === totalPages}>
        {`>>`}
      </PaginationBtnLast>
    </PaginationWrapper>
  );

  return {
    getPaginationPages,
    setCurrentPage,
    paginationComponent,
    currentPage
  };
}